import Link from 'react-router/lib/Link';
import React from 'react';
import classnames from 'classnames';
import { t } from '../../../modules/infra/i18n';
import {
  canUserViewCashRegister,
  canUserViewDailySummary,
  canUserViewCustomCharge,
} from '../../common/helpers/users';
import * as commonShapes from '../../common/shapes';
import * as shapes from '../shapes';
import { containerApp } from '../../../main';

const Header = ({
  baseUrl,
  registerOpened,
  openSidebar,
  permissions,
  canUseGiftCards,
  isRentalBarber,
  user,
  shop,
}) => (
  <div className="c-header-primary" display-if={!containerApp.isActive()}>
    <button
      className="c-hamburger u-position-absolute u-pt"
      onClick={openSidebar}
      type="button"
    >
      <span className="c-hamburger__icon" />
    </button>
    <nav className="c-header-primary__nav">
      <ul className="list-inline o-flexbox o-flexbox--justify-center">
        <li>
          <Link
            className="c-header-primary-nav-item"
            activeClassName="is-active"
            to={baseUrl}
            onlyActiveOnIndex
            data-automation-id="link:register"
          >
            {t('nav.register')}
          </Link>
        </li>
        <li display-if={canUserViewCashRegister(permissions, isRentalBarber)}>
          <Link
            className="c-header-primary-nav-item"
            activeClassName="is-active"
            to={`${baseUrl}/cash-register`}
            data-automation-id="link:cashRegister"
          >
            {t('nav.cash_register')}
            <span className={classnames('c-led u-ml--', { 'is-active': registerOpened })} />
          </Link>
        </li>
        <li display-if={canUserViewDailySummary(user, shop, permissions)}>
          <Link
            className="c-header-primary-nav-item"
            activeClassName="is-active"
            to={`${baseUrl}/summary`}
            data-automation-id="link:dailySummary"
          >
            {t('nav.daily_summary')}
          </Link>
        </li>
        <li display-if={canUserViewCustomCharge(permissions)}>
          <Link
            className="c-header-primary-nav-item"
            activeClassName="is-active"
            to={`${baseUrl}/custom-charge`}
            data-automation-id="link:customCharge"
          >
            {t('nav.custom_charge')}
          </Link>
        </li>
        <li display-if={canUseGiftCards}>
          <Link
            className="c-header-primary-nav-item"
            activeClassName="is-active"
            to={`${baseUrl}/gift-cards`}
            data-automation-id="link:giftCards"
          >
            {t('nav.gift_cards')}
          </Link>
        </li>
      </ul>
    </nav>
  </div>
);

Header.propTypes = {
  baseUrl: shapes.url,
  registerOpened: shapes.flag.isRequired,
  openSidebar: shapes.handler.isRequired,
  permissions: commonShapes.permissions.isRequired,
  canUseGiftCards: shapes.flag.isRequired,
  isRentalBarber: shapes.flag.isRequired,
  canSellMemberships: shapes.flag.isRequired,
};
Header.defaultProps = {
  baseUrl: '/register',
};

export default Header;
